import React from 'react';
import otp, { OTP } from './otp';
import dateNow, { DateNow } from './date';
import tokyoMetro, { TokyoMetro } from './tokyoMetro';

export type RootStore = {
  otp: OTP;
  dateNow: DateNow;
  tokyoMetro: TokyoMetro;
};

export const store: RootStore = {
  otp,
  dateNow,
  tokyoMetro
};

const StoreContext = React.createContext<RootStore>(store);

export const StoreProvider = StoreContext.Provider;

export const useStore = () => React.useContext(StoreContext);

export { otp };
